import * as React from "react";
import { useState, useEffect } from "react";
import esercizi from '../assets/icons/esercizi.svg';
import phone from '../assets/icons/phone.svg';
import alert from '../assets/icons/alert.svg';
import check from '../assets/icons/check.svg';
import cerchioPiu from '../assets/icons/cerchioPiu.svg';
import ButtonCreaNuovo from "../components/ButtonCreaNuovo";
import FilterBar from "../components/FilterBar";
import MiniCard from "../components/MiniCard";
import ODMTable from "../components/ODMTable";
import { useNavigate } from "react-router-dom";
import { filtersSe } from "../utils/filters";
import { Box } from '@mui/material';
import { FilterType } from "../utils/filters"
import SpinnerODM from "../components/spinnerODM";
import axios from 'axios';
import { fetchBE } from "../utils/utils";
import { Height } from "@mui/icons-material";
import { tooltipColumnIds } from "../interfaces/Sessione";

//interface ListaSessioniProps {
//  token: string;
//}

const ListaSessioni: React.FC = () => {
  const [sessions, setSessions] = useState<any[]>([]);
  const [filteredActivities, setFilteredActivities] = useState<any[]>([]);
  const [filters, setFilters] = useState<Record<string, (string | number)[]>>({});
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  const [generatedFilters, setGeneratedFilters] = useState<FilterType[]>([]);

  const THead = [
    { id: "name", label: "Nome", width: "300px" },
    { id: "status", label: "Stato", width: "100px" },
    { id: "gravity_management_complexity", label: "C.C.G", width: "150px" },
    { id: "motor_coordination_complexity", label: "C.C.M", width: "150px" },
    { id: "cardiorespiratory_complexity", label: "I.C.R", width: "150px" },
    { id: "equipment", label: "Attrezzi", width: "150px" },
    { id: "recommended_for", label: "Raccomandati per", width: "150px" },
    { id: "contraindicated_for", label: "Controindicato per", width: "150px" },
  ];

  const fetchSessions = async () => {
    setLoading(true);
    try {
      const [data, error] = await fetchBE('/api/v0/sessions')
      if (data) {
        setSessions(data);
      } else if (error) {
        if (error.message) {
          setError(error.message);
        }
      }
    } finally {
      setLoading(false);
    }
  };

  const generateFiltersFromData = (data: any[]) => {
    const filtersObject: FilterType[] = [
      { key: "active_time", name: "Tempo attivo", subFilters: [] },
      { key: "recovery_time", name: "Tempo di recupero", subFilters: [] },
    ];

    data.forEach(item => {
      filtersObject.forEach(obj => {
        const value = item[obj.key];
        if (value) {
          if (Array.isArray(value)) {
            value.forEach((v) => { if (!obj.subFilters.includes(v)) obj.subFilters.push(v) })
          } else {
            if (!obj.subFilters.includes(value)) obj.subFilters.push(value);
          }
        }
      });
    });

    return filtersObject;
  };

  useEffect(() => {
    fetchSessions();
  }, []);

  useEffect(() => {
    let updated = [...sessions];

    if (searchTerm.trim()) {
      updated = updated.filter((activity) =>
        activity.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    Object.entries(filters).forEach(([key, values]) => {
      if (values.length > 0) {
        updated = updated.filter((activity) =>
          values.includes(activity[key])
        );
      }
    });

    setFilteredActivities(updated);
  }, [sessions, filters, searchTerm]);

  if (error) return <div>Errore: {error}</div>;

  const publishedCount = sessions.filter((item) => item.status === "Published").length;
  const draftCount = sessions.filter((item) => item.status === "Draft").length;

  const transformedFilters = generatedFilters.map((obj): FilterType => {
    return {
      key: obj.key,
      name: obj.name,
      subFilters: obj.subFilters,
    }
  });

  return (
    <>
      {loading && <SpinnerODM />}

      <Box
        component="section"
        sx={{
          flexGrow: 1,
          height: "100%",
        }}
      >
        <div className="p-3 backgroundPage" style={{ height: "100%" }}>
          <div className="row">
            <div className="col">
              <h1>Lista Sessioni</h1>
              <p>Crea nuove sessioni o modifica quelle già presenti</p>
            </div>

            <div className="col-8 text-end">
              <div className="d-flex flex-wrap justify-content-end gap-3 mb-4 text-start">
                <ButtonCreaNuovo
                  onClick={() => navigate("new/edit")}
                  title="Crea nuova"
                  icon={<img src={cerchioPiu} alt="icon" width={30} />}
                />
                <MiniCard
                  name="Sessioni"
                  value={sessions.length}
                  icon={<img src={esercizi} alt="icon" width={30} />}
                />
                <MiniCard
                  name="Pubblicati"
                  value={publishedCount}
                  icon={<img src={phone} alt="icon" width={30} />}
                />
                <MiniCard
                  name="Incompleti"
                  value={draftCount}
                  icon={<img src={alert} alt="icon" width={30} />}
                  color={draftCount === 0 ? "" : "#d54a4a"}
                />
              </div>
            </div>
          </div>

          <Box
            component="section"
            sx={{
              flexGrow: 1,
              display: "flex",
              flexDirection: "row",
              height: "100%",
              overflow: "hidden",
              paddingBottom: 17   
            }}
          >
            <Box sx={{ maxWidth: 400, flexShrink: 0 }}>
              <FilterBar
                filters={transformedFilters}
                onFilterChange={setFilters}
                onSearchChange={setSearchTerm}
              />
            </Box>
            <Box
              component="section"
              sx={{
                flexGrow: 1,
                overflow: "auto",
                marginLeft: "20px",
              }}
            >
              <ODMTable
                columns={THead}
                rows={filteredActivities}
                navTable={"/sessioni/{id}"}
                edit={false}
                tooltipColumnIds={tooltipColumnIds}
              />
            </Box>
          </Box>

        </div>
      </Box>
    </>
  );
};

export default ListaSessioni;

